import Marquee from "react-fast-marquee";

const ITEMS = [
  "Sulfate Free",
  "Paraben Free",
  "Cruelty Free",
  "Salon Grade Formula",
  "Dermatologist Tested",
  "Made in India",
  "Vegan Friendly",
];

export default function MarqueeStrip() {
  return (
    <div className="marquee-strip py-5" data-testid="marquee-strip">
      <Marquee speed={36} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span key={i} className="overline mx-10 flex items-center gap-10">
            {t}
            <span className="w-1 h-1 bg-[#C9A961] rounded-full inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
